import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="App min-h-screen bg-[#F9F9F7] text-[#111A15]">
      <Header />
      <main className="pt-16 lg:pt-20"><Outlet /></main>
      <Footer />
    </div>
  );
}
